import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

// Reaproveita o layout apresentacional do DECOMP/Intersemanal (texto + galeria
// de mapas) — mesmo contrato de dados (SemanalChuva é estruturalmente igual a
// DecompChuva/IntersemanalChuva), sem necessidade de duplicar o componente.
import ChuvaLayout from 'components/Relatorios/Decomp/ChuvaLayout';
import { selectUserIsAdmin } from 'redux/reducers/authReducer';
import useSemanalSecaoParams from 'hooks/Relatorios/Semanal/useSemanalSecaoParams';
import { useGetSemanalChuvaPrevistaQuery } from 'services/api/products/relatorios';

export default function ChuvaPrevista() {
  const userIsAdmin = useSelector(selectUserIsAdmin);
  const params = useSemanalSecaoParams();

  const { data, isLoading } = useGetSemanalChuvaPrevistaQuery(params);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <ChuvaLayout
      data={data}
      canEdit={userIsAdmin}
      variant="intersemanal"
      galeriaTitulo="CHUVA PREVISTA"
    />
  );
}
